<template>
  <div class="fieldset mt-4">
    <legend class="md-whiteframe-z2" align="center">
      {{ "lng_payment_title" | translate }}
    </legend>
    <v-flex>
      <v-layout row wrap align-center>
        <v-flex xs1 md1>
          <v-btn
            @click="openHelpDialog('lng_payment_expdate_tp')"
            flat
            icon
            class="ma-0 help-ico"
          >
            <svg
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fit
              height="100%"
              width="100%"
              preserveAspectRatio="xMidYMid meet"
              focusable="false"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
              />
            </svg>
          </v-btn>
        </v-flex>

        <v-flex xs7 md7>
          <span class="subheading title-boil">
            <span>{{ "lng_payment_expdate" | translate }}</span>
          </span>
        </v-flex>

        <v-flex xs4 md4>
          <span class="subheading title-boil">
            <span>{{ formatDate(expiryDate) }}</span>
          </span>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs1 md1>
          <v-btn
            @click="openHelpDialog('lng_payment_status_tp')"
            flat
            icon
            class="ma-0 help-ico"
          >
            <svg
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fit
              height="100%"
              width="100%"
              preserveAspectRatio="xMidYMid meet"
              focusable="false"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
              />
            </svg>
          </v-btn>
        </v-flex>

        <v-flex xs7 md7>
          <span class="subheading title-boil">
            <span>{{ "lng_payment_status" | translate }}</span>
          </span>
        </v-flex>

        <v-flex xs4 md4>
          <span class="subheading title-boil">
            <span v-if="expiryFlag=='0'">{{ "lng_payment_status_expired" | translate }}</span>
            <span v-if="expiryFlag=='1'">{{ "lng_payment_status_expire_soon" | translate }}</span>
            <span v-if="expiryFlag=='2'">{{ "lng_payment_status_active" | translate }}</span>
          </span>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs1 md1>
          <v-btn
            @click="openHelpDialog('lng_pay_one_year_tp')"
            flat
            icon
            class="ma-0 help-ico"
          >
            <svg
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fit
              height="100%"
              width="100%"
              preserveAspectRatio="xMidYMid meet"
              focusable="false"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
              />
            </svg>
          </v-btn>
        </v-flex>

        <v-flex xs7 md7>
          <span class="subheading title-boil">
            <span>{{ "lng_pay_one_year_text" | translate }}</span>
          </span>
        </v-flex>

        <v-flex xs4 md4>
          <v-btn
            class="timer-btn"
            :loading="showLoading"
            @click="openBeforePaymentDialog"
            >{{ "lng_payment_btn_text" | translate }}</v-btn
          >
        </v-flex>
      </v-layout>
    </v-flex>
    <help-dialog
      :help-text="selectedHelpText"
      :openDialog="helpDialogtoggle"
      :closeDialog="closeHelpDialog"
    ></help-dialog>
    <before-payment-email
      :userMenuData="userMenuData"
      :openDialog="beforePaymentDialog"
      :closeDialog="closeBeforePaymentDialog"
      :saveSuccess="openPaymentPage"
    ></before-payment-email>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { translate } from "../common/HelperFunctions";
import GlobalService from "../services/global-service";
import HelpDialog from "./HelpDialog";
import moment from "moment";
import BeforePaymentEmail from "../components/BeforePaymentEmail.vue";

export default {
  name: "PaymentInvoicesMenu",
  data() {
    return {
      expiryDate: "",
      helpDialogtoggle: false,
      selectedHelpText: "",
      showLoading: false,
      expiryFlag: '2',
      beforePaymentDialog: false,
    };
  },
  // modal components for "show help text", "update field value" and "give technical access"
  components: {
    HelpDialog,
    BeforePaymentEmail
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("global", ["getTechAccess"]),
    ...mapGetters("global", ["getAccessMode"])
  },
  created() {
    this.expiryDate = localStorage.getItem("expirydate");
    this.expiryFlag = localStorage.getItem("expiryFlag");
  },
  mounted() {},
  methods: {
    formatDate(date) {
      return moment.utc(date).format("DD-MMM-YYYY");
    },
    selectInvoiceDate(invoiceData) {
      if (invoiceData.paymenturl) {
        window.open(invoiceData.paymenturl, "_blank");
      }
    },
    openHelpDialog(helpText) {
      this.selectedHelpText = translate(helpText);
      this.helpDialogtoggle = true;
    },
    // close Help text showing dialog
    closeHelpDialog() {
      this.helpDialogtoggle = false;
    },
    async openPaymentPage(email) {
      this.showLoading = true;

      let data = this.userMenuData;
      let userInfoURL = `email=${email}&name=${data["user.name"].val}&city=${data["user.city"].val}&country=${'DK'}&address1=${data["user.address"].val}&address2=${''}&zip=${data["user.zip"].val}&serial=${data["user.serial"].val}&locale=${localStorage.getItem("language")}`

      let paymentDetails = await GlobalService.getStripePaymentLink(userInfoURL);
      location.href = paymentDetails.paymentlink;
      this.showLoading = false;
    },
    // open Clear Ignition dialog
    openBeforePaymentDialog() {
      this.beforePaymentDialog = true;
    },
    // close Clear Ignition dialog
    closeBeforePaymentDialog() {
      this.beforePaymentDialog = false;
    },
  },
  props: {
    paymentInvoices: {
      type: Array,
      default: () => []
    },
    userMenuData: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style>
.v-messages__message {
  margin-top: 5px;
}
.fieldset {
  margin: 0 0 20px;
  padding: 35px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: 2px solid #455a64;
  background: rgba(255, 255, 255, 0.3);
}
.fieldset legend {
  margin: 0 auto;
  text-transform: capitalize;
  padding: 10px;
  font-size: 18px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  background: #455a64;
  color: #fff;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  top: -30px;
  margin-top: -30px;
  position: relative;
}
.md-whiteframe-z2 {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.help-ico svg {
  width: 36px;
  height: auto;
  fill: #455a64;
}
@media (max-width: 768px) {
  .sub-menu {
    display: none !important;
  }
  .panel-block {
    padding: 0 !important;
    margin-bottom: 10px;
  }
}
@media (max-width: 480px) {
  .fieldset {
    padding: 20px 15px;
  }
  .help-ico svg {
    width: 28px;
  }
  .title-boil {
    font-size: 12px !important;
    padding: 0 6px;
  }
  .fieldset legend {
    top: -15px;
  }
  .panel-block .v-input__slot {
    margin-bottom: 0;
  }
  .fieldset button {
    position: relative;
    left: -10px;
  }
  .fieldset button div {
    font-size: 10px;
    line-height: 14px;
    white-space: normal;
  }
  .v-select__selections {
    padding-right: 0px;
    word-break: break-word;
    font-size: 12px;
    line-height: 14px;
  }
  .fieldset .v-input label {
    font-size: 12px;
  }
}
</style>
